export default __webpack_public_path__ + "tmp_src/components/BreadCrumbs/BreadCrumbs~aurora.css.liquid";